import { Component, inject, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Notice, NoticeWithUnreadMessageDto, NoticeType} from '../../types';
import { PCP_URL } from "../../types/constants/appconstants";

@Component({
  selector: 'notice-card',
  templateUrl: './notice-card.component.html',
  styleUrls: ['./notice-card.component.scss'],
  standalone: true,
    imports: [CommonModule, Button, TooltipModule]
})
export class NoticeCardComponent {
  private pcpBaseUrl = inject(PCP_URL);
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() notice: Notice | NoticeWithUnreadMessageDto | null = null;
  readonly closeSidebar = output<void>();
  readonly dismissNotice = output<number>();

  NoticeType = NoticeType;
  onDismiss() {
    this.dismissNotice.emit(this.notice?.constructionUpdate?.noticeId ?? this.notice?.noticeId);
  }

  onGoToLotConstructionUpdates(event: Event, noticeId: number, notice: any) {
    event.preventDefault();
    this.dismissNotice.emit(noticeId);
    // TODO: The 'emit' function requires a mandatory void argument
  this.closeSidebar.emit(null);

    const lotId = notice?.constructionUpdate?.lotId;
    const communityName = encodeURIComponent(notice?.constructionUpdate?.communityName ?? '');
    const lotBlock = encodeURIComponent(notice?.constructionUpdate?.lotBlock ?? '');

    const url = `${this.pcpBaseUrl}schedules/constructionlotupdates/${lotId}?communityName=${communityName}&lotBlock=${lotBlock}`;
    window.location.href = url;
  }

  onGoToLotMessages(event: Event, notice: any) {
    event.preventDefault();
    // TODO: The 'emit' function requires a mandatory void argument
  this.closeSidebar.emit(null);

    const lotId = notice?.lotId;
    const communityName = encodeURIComponent(notice?.financialCommunityName ?? '');
    const communityNumber = encodeURIComponent(notice?.financialCommunityNumber ?? '');
    const lotBlock = encodeURIComponent(notice?.lotBlock ?? '');

    const url = `${this.pcpBaseUrl}schedules/constructionlotmessages/${lotId}?communityName=${communityName}&communityNumber=${communityNumber}&lotBlock=${lotBlock}`;
    window.location.href = url;
  }

}
